var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9993 0.0292969C10.4361 0.0292969 9.8732 0.29174 9.55792 0.816406L0.761049 15.4512C0.112816 16.5292 0.942201 18 2.2005 18H19.7962C21.0541 18 21.8858 16.5292 21.2376 15.4512L12.4407 0.816406C12.1255 0.29174 11.5625 0.0292969 10.9993 0.0292969ZM10.9993 2.29883L19.2357 16H2.763L10.9993 2.29883ZM9.99933 6V11H11.9993V6H9.99933ZM9.99933 13V15H11.9993V13H9.99933Z",
    fill: "#D96262"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.582c7b65.svg";
export { ForwardRef as ReactComponent };